export const MapFeatureCategories = [
  "Attractions",
  "Beaches & Surf",
  "Cities & Towns",
  "Cultural & Historic",
  "Hikes & Views",
  "National Parks",
  "Scenic Roads",
  "Waterfall",
  "Wildlife",
];

export const MapFeatureCountries = [
  "Argentina",
  "Belize",
  "Bolivia",
  "Brazil",
  "Canada",
  "Chile",
  "Costa Rica",
  "Colombia",
  "Ecuador",
  "El Salvador",
  "Guatemala",
  "Honduras",
  "Mexico",
  "Nicaragua",
  "Panama",
  "Peru",
  "USA",
  "Uruguay",
];
